module.exports = __webpack_public_path__ + "static/media/rg-back.220617b1.svg";